(function () {
    angular.module('app')
        .factory('lazyPartialService', lazyPartialService);

    lazyPartialService.$inject = ['$http'];
    function lazyPartialService($http) {
        return {
            getPartial: function (pageId, partial) {
                return $http.get('/api/main/partial', {
                    params: {
                        pageId: pageId,
                        partial: partial
                    }
                });
            }
        };
    }
})();